module.exports = __webpack_public_path__ + "static/media/category-core.62c481da.svg";